module.exports = __webpack_public_path__ + "static/media/icn_tax_made_simple.ccfa1065.svg";